import React, { useEffect, useState } from 'react';

export interface PaginationProps {
  current?: number;
  pageSize?: number;
}

export interface UsePaginationParams {
  total: number;
  current?: number;
  pageSize?: number;
}

export const usePagination = ({ total, current = 0, pageSize = 5 }: UsePaginationParams) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(total / pageSize);

  useEffect(() => {
    setCurrentPage(current);
  }, [current]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => prev - 1);
  };

  return {
    totalPages,
    paginatedProps: {
      current: currentPage,
      pageSize
    },
    handlePageChange,
    handleNextPage,
    handlePrevPage
  };
};
